import React from 'react';
import { FieldValue } from 'api/notifications/meta';
import { unreachable } from 'utils/unreachable';
import { ReadableTag } from '../../basics';
import { DateView } from '../date';
import { UserView } from '../user-view';

const renderFieldValueOnly = (field: FieldValue) => {
  switch (field.type) {
    case 'Boolean':
      return <>{field.value.toString()}</>;
    case 'Date':
      return <DateView timestamp={field.value} />;
    case 'Number':
      return <>{field.value}</>;
    case 'Text':
      return <>{field.value}</>;
    case 'User':
      return <UserView user={field.value} />;
    default:
      return unreachable(field);
  }
};

export const renderFieldValue = (field?: FieldValue) => {
  if (field == null) {
    return null;
  }
  const fieldValue = renderFieldValueOnly(field);

  return field.color ? (
    <ReadableTag color={field.color}>{fieldValue}</ReadableTag>
  ) : (
    fieldValue
  );
};
